<div class="tw-flex tw-justify-between tw-items-center tw-font-body tw-mt-3 tw-mb-1 tw-px-4">
  <h3 class="tw-text-gray-900 tw-font-bold" [class.tw-text-200]="isDravidianScriptUser" i18n="@@checkPlansMadeForYou"> Check plans made for you </h3>
  @if (!regimen?.orderPlaced) {
    <h3 id="read-more" class="tw-flex tw-items-center tw-text-100 tw-lowercase tw-font-bold tw-text-teal-600" [class.tw-mr-2]="!isDravidianScriptUser" (click)="readMore()">
      @if(instructionsVisibilityExp) {
        <span i18n="@@compare">Compare</span>
      } @else {
        <span i18n="@@readMore">Read More</span>
      }
      @if (!regimen?.orderPlaced) {
        <cs-icon class="tw-h-4 tw-w-4 tw-ml-1 tw-animate-bounce_x tw-text-teal-600" (click)="readMore()" [iconName]='"chevron_right"'></cs-icon>
      }
    </h3>
  }
</div>
<section class="tw-font-body tw-overflow-scroll tw-pb-3" #scroll>
  <div class="tw-flex tw-text-center tw-pl-2" [ngClass]="{'tw-mt-2': showIntroductoryKit || showAdvanceTag, 'tw-text-100': user?.get('languagePreference') === 'ta', 'tw-text-300': user?.get('languagePreference') !== 'ta'}">

    <!-- Render plans in order -->
    @if (templatesReady) {
      @for (planName of getOrderedPlans(); track planName) {
        @if (shouldShowPlan(planName)) {
          <ng-container *ngTemplateOutlet="planTemplates[planName]; context: { planName: planName }"></ng-container>
        }
      }
    }

    <!-- Trailing spacer so the last card isn't flush against the scroll edge -->
    <div class="tw-shrink-0 tw-w-2" aria-hidden="true"></div>

  </div>
</section>

<!-- Plan Templates -->
<ng-template #introductoryPlan let-planName="planName">
  <div class="tw-mx-1 tw-overflow-visible tw-flex-1 tw-relative tw-rounded-xl tw-my-2 tw-shadow-z1" [ngStyle]="{ 'background-image': selectedPlan === planName ? 'url(/assets/images/gold-shine.gif)' : 'none' }">
    <div id="introductory" class="tw-overflow-visible tw-rounded-xl" [ngStyle]="{'margin': selectedPlan === planName ? '3px' : '1px'}" style="min-width: 178px; max-height: 90px" [ngClass]="{'tw-bg-teal-100': selectedPlan === planName, 'tw-bg-gray-100': selectedPlan !== planName, 'shine': selectedPlan === planName}" (click)="selectPlan(planName)">
      <div class="tw-rounded-xl tw-rounded-b-none tw-flex tw-items-center tw-justify-center" [ngClass]="{'tw-bg-teal-200': selectedPlan === planName, 'tw-bg-gray-200': selectedPlan !== planName}">
        @if (selectedPlan === planName) {
          <img class="tw-mx-1 tw-w-[15px] tw-h-[15px]" src="/assets/images/correct.png" />
        }
        <span class="tw-font-bold">
          <span>3&nbsp;</span>
          <span i18n="@@products">Products</span>
          <span>&nbsp;</span>
          <span>&#64; ₹{{variantCosts.introductory}}</span>
        </span>
      </div>
      <div class="tw-px-1 tw-p-2" style="color: #2f2f2f" [ngClass]="{'tw-text-100': user?.get('languagePreference') === 'ta', 'tw-text-200': user?.get('languagePreference') !== 'ta'}">
        <p i18n="@@seeImprov89">Improvement starts in <br /><b> 8-9 weeks</b></p>
      </div>
    </div>
    <div class="tw-absolute gold-button shine loop tw-font-bold tw-text-200 tw-z-100 tw-px-2 tw-top-[-12px] tw-left-[15px]" i18n="@@newPlan"> NEW </div>
  </div>
</ng-template>

<ng-template #advancePlan let-planName="planName">
  <div id="advance" class="tw-rounded-xl tw-mx-1 tw-my-2 tw-border tw-border-gray-200 tw-flex-1 tw-shadow-z1 tw-relative" style="min-width: 178px; max-height: 90px" [ngClass]="{'tw-bg-teal-100': selectedPlan === planName, 'tw-bg-gray-100': selectedPlan !== planName, 'tw-mt-3': selectedPlan === 'introductory' && showIntroductoryKit}" (click)="selectPlan(planName)">
    <div class="tw-flex tw-items-center tw-justify-center tw-rounded-t-xl tw-h-[30px]" [ngClass]="{'tw-bg-teal-200': selectedPlan === planName, 'tw-bg-gray-200': selectedPlan !== planName }">
      @if (selectedPlan === planName) {
        <img class="tw-mx-1 tw-w-[15px] tw-h-[15px]" src="/assets/images/correct.png" />
      }
      <span class="tw-font-bold">
        <span>4&nbsp;</span>
        <span i18n="@@products">Products</span>
        <span>&nbsp;</span>
        <span>&#64; ₹{{variantCosts.advance}}</span>
      </span>
    </div>
    <div class="tw-px-1 tw-p-2" style="color: #2f2f2f" [ngClass]="{'tw-text-100': user?.get('languagePreference') === 'ta', 'tw-text-200': user?.get('languagePreference') !== 'ta'}">
      <p i18n="@@seeImprov46">Improvement starts in <br /><b>4-6 weeks</b></p>
    </div>
  </div>
</ng-template>

<ng-template #proPlan let-planName="planName">
  <!-- Pro plan with ADVANCE tag -->
  @if (showAdvanceTag && !showIntroductoryKit) {
    <div class="tw-mx-1 tw-overflow-visible tw-flex-1 tw-relative tw-rounded-xl tw-my-2 tw-shadow-z1" [ngStyle]="{ 'background-image': selectedPlan === planName ? 'url(/assets/images/gold-shine.gif)' : 'none' }">
      <div id="pro" class="tw-overflow-visible tw-rounded-xl" style="min-width: 178px; max-height: 90px" [ngStyle]="{'margin': selectedPlan === planName ? '3px' : '1px'}" [ngClass]="{'tw-bg-orange-100': selectedPlan === planName, 'tw-bg-gray-100': selectedPlan !== planName}" (click)="selectPlan(planName)">
        <div class="tw-h-[30px] tw-rounded-xl tw-rounded-b-none tw-flex tw-items-center tw-justify-center" [ngClass]="{'tw-bg-orange-200': selectedPlan === planName, 'tw-bg-gray-200': selectedPlan !== planName}">
          @if (selectedPlan === planName) {
            <img class="tw-mx-1 tw-w-[15px] tw-h-[15px]" src="/assets/images/correct.png" />
          }
          <span class="tw-font-bold">
            <span>5&nbsp;</span>
            <span i18n="@@products">Products</span>
            <span>&nbsp;</span>
            <span>&#64; ₹{{variantCosts.pro}}</span>
          </span>
        </div>
        <div class="tw-px-1 tw-p-2" style="color: #2f2f2f" [ngClass]="{'tw-text-100': user?.get('languagePreference') === 'ta', 'tw-text-200': user?.get('languagePreference') !== 'ta'}">
          <p class="tw-mb-1" i18n="@@seeImprov34">Improvement starts in <br /><b>3-4 weeks</b></p>
        </div>
      </div>
      <div class="tw-absolute gold-button tw-font-bold tw-text-200 tw-z-100 tw-px-2 tw-top-[-12px] tw-left-[15px]" i18n="@@advanceTxt"> ADVANCE </div>
    </div>
  }

  <!-- Pro plan without ADVANCE tag -->
  @if (!showAdvanceTag || showIntroductoryKit) {
    <div id="pro" class="tw-rounded-xl tw-mx-1 tw-my-2 tw-border tw-border-gray-200 tw-flex-1 tw-shadow-z1 tw-relative" style="min-width: 178px; max-height: 90px" [ngClass]="{'tw-bg-orange-100': selectedPlan === planName, 'tw-bg-gray-100': selectedPlan !== planName, 'tw-mt-3': selectedPlan === 'introductory' && showIntroductoryKit}" (click)="selectPlan(planName)">
      <div class="tw-h-[30px] tw-flex tw-items-center tw-justify-center tw-rounded-t-xl" [ngClass]="{'tw-bg-orange-200': selectedPlan === planName, 'tw-bg-gray-200': selectedPlan !== planName}">
        @if (selectedPlan === planName) {
          <img class="tw-mx-1 tw-w-[15px] tw-h-[15px]" src="/assets/images/correct.png" />
        }
        <span class="tw-font-bold">
          <span>5&nbsp;</span>
          <span i18n="@@products">Products</span>
          <span>&nbsp;</span>
          <span>&#64; ₹{{variantCosts.pro}}</span>
        </span>
      </div>
      <div class="tw-px-1 tw-p-2" style="color: #2f2f2f" [ngClass]="{'tw-text-100': user?.get('languagePreference') === 'ta', 'tw-text-200': user?.get('languagePreference') !== 'ta'}">
        <p class="tw-mb-1" i18n="@@seeImprov34">Improvement starts in <br /><b>3-4 weeks</b></p>
      </div>
    </div>
  }
</ng-template>

<ng-template #assistPlan let-planName="planName">
  <div id="assist" class="tw-rounded-xl tw-mx-1 tw-my-2 tw-border tw-border-gray-200 tw-flex-1 tw-shadow-z1 tw-relative tw-max-h-[90px] tw-min-w-[190px]" [ngClass]="{'tw-bg-blue-100': selectedPlan === planName, 'tw-bg-gray-100': selectedPlan !== planName, 'tw-mt-3': selectedPlan === 'introductory' && showIntroductoryKit}" (click)="selectPlan(planName)">
    <div class="tw-h-[30px] tw-flex tw-items-center tw-justify-center tw-rounded-t-xl" [ngClass]="{'tw-bg-blue-200': selectedPlan === planName, 'tw-bg-gray-200': selectedPlan !== planName}">
      @if (selectedPlan === planName) {
        <img class="tw-mx-1 tw-w-[15px] tw-h-[15px]" src="/assets/images/correct.png" />
      }
      <span class="tw-font-bold" i18n="@@5Prod1to1Assist">5 Products &#64; ₹{{variantCosts.assist}}</span>
    </div>
    <div class="tw-px-1 tw-p-2" [ngClass]="{'tw-text-100': user?.get('languagePreference') === 'ta', 'tw-text-200': user?.get('languagePreference') !== 'ta'}">
      <p i18n="@@seeImprov1to1">See improvement with <br /><b>Doctor video call</b></p>
    </div>
  </div>
</ng-template>
